import React, { useEffect, useImperativeHandle, useRef, useState, forwardRef } from "react";

// Wiederverwendbares Unterschriftenfeld (Maus, Trackpad, Finger). ref: { clear(), toDataURL(), isEmpty() }
const SignaturePad = forwardRef(function SignaturePad({ height = 220, onChange, testId = "signature-pad", disabled = false }, ref) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [hasSig, setHasSig] = useState(false);

  useEffect(() => {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    ctx.lineWidth = 2.4; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#0A192F";
  }, []);

  const pos = (e) => {
    const c = canvasRef.current;
    const r = c.getBoundingClientRect();
    const t = e.touches?.[0];
    const x = (t?.clientX ?? e.clientX) - r.left;
    const y = (t?.clientY ?? e.clientY) - r.top;
    return { x: x * (c.width / r.width), y: y * (c.height / r.height) };
  };
  const start = (e) => {
    if (disabled) return;
    e.preventDefault();
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const p = pos(e);
    ctx.beginPath(); ctx.moveTo(p.x, p.y);
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const p = pos(e); ctx.lineTo(p.x, p.y); ctx.stroke();
    if (!hasSig) { setHasSig(true); onChange?.(true); }
  };
  const stop = () => { drawing.current = false; };

  useImperativeHandle(ref, () => ({
    clear() {
      const c = canvasRef.current;
      c.getContext("2d").clearRect(0, 0, c.width, c.height);
      setHasSig(false); onChange?.(false);
    },
    toDataURL() { return canvasRef.current.toDataURL("image/png"); },
    isEmpty() { return !hasSig; },
  }));

  return (
    <div className="relative">
      <canvas
        ref={canvasRef}
        width={900}
        height={Math.round(height * (900 / 700))}
        style={{ height }}
        className={`w-full bg-white rounded-xl border-2 border-dashed ${hasSig ? "border-[#1A2238]" : "border-[#C9CDD6]"} touch-none ${disabled ? "opacity-60" : "cursor-crosshair"}`}
        onMouseDown={start} onMouseMove={move} onMouseUp={stop} onMouseLeave={stop}
        onTouchStart={start} onTouchMove={move} onTouchEnd={stop}
        data-testid={testId}
      />
      {!hasSig && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <span className="text-sm text-[#9CA3AF]">Hier mit Finger oder Maus unterschreiben</span>
        </div>
      )}
      <div className="absolute left-6 right-6 bottom-9 border-b border-[#D1D5DB] pointer-events-none" />
    </div>
  );
});

export default SignaturePad;
